var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('MyHeader'),_c('div',{staticClass:"container",staticStyle:{"margin-top":"50px","margin-bottom":"100px"}},[_c('router-view')],1),_c('MyFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }